import { FC } from 'react'
import { ReactComponent as DoubleCheckIcon } from 'src/assets/svg/double-check-white.svg'
import { CampaignSourceRow } from 'src/components/CampaignSourceSelector/interfaces/campaignSource.interface'
import {
  getCampaignUnitLabel,
  getSourceEntityLabel,
} from 'src/components/CampaignSourceSelector/useCampaignSources'
import styles from './campaignsSummary.module.scss'

interface CampaignsSummaryProps {
  sources: CampaignSourceRow[]
}

export const CampaignsSummary: FC<CampaignsSummaryProps> = ({ sources }) => (
  <div className={styles.campaignsSummaryGroups}>
    {sources.map((source) => {
      const SourceIcon = source.icon

      return (
        <div className={styles.campaignsSummaryGroup} key={source.id}>
          <div className={styles.campaignsSummaryGroupHeader}>
            <div className={styles.campaignsSummaryGroupLeft}>
              <SourceIcon
                className={styles.campaignsSummarySourceIcon}
                style={{ color: source.color }}
              />
              <span>{source.label}</span>
            </div>

            <div className={styles.campaignsSummaryCountPill}>
              {source.campaigns.length}{' '}
              {getSourceEntityLabel(source.id, source.campaigns.length)}
            </div>
          </div>

          <div className={styles.campaignsSummaryDivider} />

          <div className={styles.campaignsSummaryCards}>
            {source.campaigns.map((campaign) => (
              <div
                className={styles.campaignsSummaryCampaignCard}
                key={campaign.id}
              >
                <div className={styles.campaignCardLeft}>
                  <span className={styles.selectedCheckbox}>
                    <DoubleCheckIcon className={styles.selectedCheckboxIcon} />
                  </span>

                  <div className={styles.campaignCardText}>
                    <span className={styles.campaignCardTitle}>
                      {campaign.title}
                    </span>
                    <span className={styles.campaignCardCategory}>
                      {campaign.category}
                    </span>
                  </div>
                </div>

                <div className={styles.campaignMentions}>
                  <span className={styles.campaignMentionsValue}>
                    {campaign.mentions}
                  </span>
                  <span className={styles.campaignMentionsLabel}>
                    {getCampaignUnitLabel(
                      campaign.sourceId,
                      campaign.mentionsCount
                    )}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )
    })}
  </div>
)
